module.exports = __webpack_public_path__ + "static/media/router.4c950517.svg";